/* eslint-disable react/jsx-props-no-spreading */
import { NavLink } from 'react-router';
import type { NavLinkProps } from 'react-router';

interface ActiveNavLinkProps extends NavLinkProps {
  children: React.ReactNode;
}

function ActiveNavLink({
  children,
  to,
  end,
  ...rest
}: ActiveNavLinkProps) {
  return (
    <NavLink
      to={to}
      end={end}
      className={(params: { isActive: boolean }) => `hover:text-gray-300${params.isActive ? ' underline font-bold' : ''}`}
      {...rest}
    >
      {children}
    </NavLink>
  );
}

export default ActiveNavLink;
